var map = {
	"./assets/biz.png": "0cbc",
	"./assets/common": "8e9a",
	"./assets/common.js": "8e9a",
	"./assets/css/index.css": "a2f0",
	"./assets/css/quillfont.css": "9170",
	"./assets/kefuQr.png": "c66b",
	"./assets/logo.jpg": "b640",
	"./assets/logo.png": "cf05",
	"./assets/logoback.jpg": "b1ae",
	"./assets/logojpg.jpg": "c88d",
	"./assets/qrwechat.jpg": "18fa",
	"./assets/qrwechatmini.jpg": "6c99",
	"./assets/report.png": "86f2",
	"./assets/stickerQr.jpg": "0eff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";